var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{class:_vm.active,staticStyle:{"transition":"1s"},attrs:{"value":_vm.overlay,"color":"#FF9D2A","opacity":_vm.opacity,"z-index":"30"}},[_c('div',{staticClass:"d-flex"},[_c('img',{attrs:{"src":"/img/mori_motors_new_logo_animation.gif","alt":"/img/mori_motors_new_logo_animation.gif"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }